<template>
    <div class="flex">
        <div @click="showModal('test')" class="btn btn-sm btn-blue text-white cursor-pointer">
            <i class="fas fa-mobile"></i>
            Text Alerts
        </div>
    </div>

    <modal id="text-alert-modal-notifications" @close="closeModal" v-if="modalType === 'notifications'">
        <template #header>
            Text Alert Settings
        </template>

        <template #body>
            <p class="text-base leading-tight mb-4">
                You have not activated text alert notifications.
            </p>

            <p class="text-base leading-tight mb-4">
                Please visit the <a :href="getNotifPage()">Notification Preferences</a> to add a phone number and adjust your settings.
            </p>
        </template>

        <template #footer>
            <div class="flex justify-center">
                <div @click="closeModal" class="btn btn-sm btn-yellow-ghost">
                    Close
                </div>
            </div>
        </template>
    </modal>

    <modal id="text-alert-modal-notificationPage" @close="closeModal" v-if="modalType === 'notificationPage'">
        <template #header>
            Text Alert Settings
        </template>

        <template #body>
            <p class="text-base leading-tight mb-4">
                Check the boxes below to receive text notifications:
            </p>
            <div class="text-base mb-2 leading-tight" v-for="(notification, index) in form.notifications">
                <input v-model="form.notifications[index].enabled" :value="notification" :checked="notification.enabled" :id="`${notification.type}-${notification.name}`" type="checkbox">
                <label :for="`${notification.type}-${notification.name}`" class="ml-2">{{ notification.display }}</label>
            </div>
            <div class="flex justify-center">
                <a :href="getNotifPage()">See All Notification Preferences</a>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-center">
                <div @click="closeModal" class="m-1 btn btn-sm btn-yellow-ghost">
                    Close
                </div>
                <div @click="save" class="btn m-1 btn-sm btn-yellow">
                    Save
                </div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    defaultNotifications: Array,
});

const $clone = (obj) => JSON.parse(JSON.stringify(obj));
const modalType = ref(false);
const notifications = ref(props.defaultNotifications);
const form = ref({
    notifications: $clone(props.defaultNotifications),
});

const hasPhone = computed(() => {
    return window.currentUser.phone_number && window.currentUser.phone_number.startsWith('+');
});

const showModal = (type) => {
    if (hasPhone.value) {
        modalType.value = 'notificationPage';
    } else {
        modalType.value = 'notifications';
    }
};

const closeModal = () => {
    modalType.value = false;
    form.value.notifications = $clone(notifications.value);
};

const getNotifPage = () => {
    return window.route('main.profile.notifications');
};

const save = () => {
    const route = window.route('main.profile.notifications.update-batch');

    const params = {
        notifications: form.value.notifications.map((mNotification) => {
            mNotification.property = 'sms';
            return mNotification;
        }),
    };

    notifications.value = $clone(params.notifications);

    axios
        .post(route, params)
        .catch((error) => {
            // Handle the error
        })
        .then(() => {
            modalType.value = false;
        });
};
</script>

<style>
#text-alert-modal-notifications #modalWindowWrapper,
#text-alert-modal-notificationPage #modalWindowWrapper {
    width: 26rem;
}
</style>
